import { useTranslation } from 'react-i18next';
import { PreviewContainer } from '../../../style';
import { useTemplateEditorState } from '../../../../context/UseTemplateEditorContext';

export const TemplatePreviewView = () => {
  const { t } = useTranslation('designs');
  const { compiledTemplate } = useTemplateEditorState();

  const injected = compiledTemplate + '\n<script src="/countdown.js"></script>';

  return (
    <PreviewContainer data-testid="PreviewView">
      <iframe
        data-testid="PreviewViewContent"
        title={t('designGallery.templateEditor.templatePreviewView.iframeTitle')}
        srcDoc={injected}
        style={{ display: 'block', height: '100%' }}
      />
    </PreviewContainer>
  );
};
